import React from 'react';
import { Trans } from 'react-i18next';

import TaskGroupContainer from '../containers/task-group-container';

const Name = ({ name = null, removed }) => removed ? <React.Fragment>(<Trans i18nKey="task:Removed Status" />)</React.Fragment> : name;

const TaskGroupName = ({ id }) => <TaskGroupContainer id={id}><Name /></TaskGroupContainer>;

export default TaskGroupName;
